import { useTranslation } from "react-i18next";

import adyen from "../../assets/images/adyen.svg";

function NoDataOverlay() {
  const { t } = useTranslation();
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <img
          src={adyen}
          width="400"
          height="300"
          alt="No data"
        />
        <p
          style={{
            fontWeight: "bold",
            fontFamily: "Segoe UI",
            fontSize: "18px",
          }}
        >
          {t("No payments found.")}
        </p>
        <p style={{ fontFamily: "Segoe UI", fontSize: "12px" }}>
          {t("Try a different search or reset your filters.")}
        </p>
      </div>
    </div>
  );
}

export default NoDataOverlay;
